import React from 'react'

const PhotoUploadSection = ({
  selectedEvent,
  selectedFile,
  previewUrl,
  uploading,
  onFileSelect,
  onSubmit,
  onReset
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold text-white">
          Upload Stamp Photo for {selectedEvent.name}
        </h2>
        <button
          onClick={onReset}
          className="text-sm font-medium px-3 py-1 rounded-lg border border-white/20 hover:bg-white/10 transition-all duration-300 text-gray-300"
        >
          Change Event
        </button>
      </div>

      <PhotoRequirements />

      <PhotoUpload
        onFileSelect={onFileSelect}
        previewUrl={previewUrl}
      />

      <SubmitButton
        selectedFile={selectedFile}
        uploading={uploading}
        onSubmit={onSubmit}
      />
    </div>
  )
}

const PhotoRequirements = () => (
  <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
    <h3 className="font-semibold mb-2 text-white">
      📸 Photo Requirements
    </h3>
    <p className="text-sm text-gray-300">
      Your photo must be a <strong>selfie</strong> taken in front of something inside the festival grounds that is
      <strong> branded by the festival</strong>. This could include:
    </p>
    <ul className="list-disc list-inside mt-2 text-sm space-y-1 text-gray-400">
      <li>The main stage with festival branding</li>
      <li>A giant festival logo or sign</li>
      <li>The festival entrance or gates</li>
      <li>Unique decorations specific to this festival</li>
      <li>Official festival installations or art pieces</li>
    </ul>
  </div>
)

const PhotoUpload = ({ onFileSelect, previewUrl }) => (
  <div className="space-y-4">
    <input
      type="file"
      accept="image/*"
      onChange={onFileSelect}
      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10"
    />

    {previewUrl && (
      <div className="mt-4">
        <img
          src={previewUrl}
          alt="Stamp preview"
          className="w-full max-w-md mx-auto rounded-xl shadow-lg"
        />
      </div>
    )}
  </div>
)

const SubmitButton = ({ selectedFile, uploading, onSubmit }) => (
  <div className="flex justify-center">
    <button
      onClick={onSubmit}
      disabled={!selectedFile || uploading}
      className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 disabled:from-gray-600 disabled:to-gray-600 text-white font-semibold py-3 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
    >
      {uploading ? 'Adding Stamp...' : 'Add Stamp to Passport'}
    </button>
  </div>
)

export default PhotoUploadSection